// API Reference: https://www.wix.com/velo/reference/api-overview/introduction
// “Hello, World!” Example: https://learn-code.wix.com/en/article/1-hello-world

$w.onReady(function () {
	// Write your JavaScript here
<script async src='https://tag.simpli.fi/sifitag/a4239530-e8b0-0139-b9d1-06a60fe5fe77'></script>
	// To select an element by ID use: $w("#elementID")

	// Click "Preview" to run your code
});